<template>
  <div>
    <div class="col-mr-5 mt-3">
      <right-panel class="float-right" id="sidebar-new-physical-storage" width="800px" :icon="'mdi mdi-plus'" :text="$t('physical-storage.new')">
        <div class="pl-5 pr-5">
          <FormPhysicalStorage @onFormSave="onStorageSelect" :inventory="true" :hide-library="true" />
        </div>
      </right-panel>
    </div>

    <h6>{{ $t("physical-storage.text") }}</h6>

    <filter-select
      id="storageFilter"
      ref="storageFilter"
      :placeholder="$t('physical-storage.text')"
      :multiple="true"
      :max="5"
      @filter="onStorageSearch"
      :selected="form.libraryItem"
      @changed="onStorageSelect"
    />

    <div class="mt-3">
      <sweet-input :isValid="true" v-model="form.since" layout="vertical" :placeholder="$t('physical-storage.since')" :label="$t('physical-storage.since')" />
    </div>

    <b-row class="mt-3">
      <b-col>
        <sweet-input
          :isValid="!$v.form.period.$error"
          @input="$v.form.period.$touch()"
          v-model="form.period"
          type="number"
          layout="vertical"
          :placeholder="$t('physical-storage.period')"
          :label="$t('physical-storage.period')"
        />
      </b-col>
      <b-col>
        <h6>{{ $t("common.unit") }}</h6>
        <select v-model="unit" class="form-control form-control">
          <option value="year">{{ $t("common.year") }}</option>
          <option value="month">{{ $t("common.month") }}</option>
        </select>
      </b-col>
    </b-row>

    <div class="mt-3">
      <sweet-input :isValid="true" v-model="form.legalBasis" layout="vertical" :placeholder="$t('physical-storage.legal-basis')" :label="$t('physical-storage.legal-basis')" />
    </div>

    <div class="mt-3">
      <sweet-input :isValid="true" v-model="form.description" layout="vertical" :placeholder="$t('common.description')" :label="$t('common.description')" />
    </div>

    <sweet-button @click="save()" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>

    <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
      {{ $t("common.cancel") }}
    </sweet-button>
    <storage-period-recommendation @onApply="applyRecommendation" />
  </div>
</template>

<script>
import FormPhysicalStorage from "@modules/storage-environments/physical-storage/workspace-library-physical-storage-form";
import { required } from "vuelidate/lib/validators";
import StoragePeriodRecommendation from "../recommendation/storage/storage-period-recommendation.vue";

export default {
  props: ["prepareMode", "id"],
  components: { FormPhysicalStorage, StoragePeriodRecommendation },
  validations: {
    form: {
      libraryItem: {
        required,
      },
      period: {
        required,
      },
    },
  },
  data() {
    return {
      form: { libraryItem: undefined, period: 12, since: undefined, legalBasis: undefined, description: undefined },
      unit: "month",
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["datasourcePhysicalStorage/isUpdating"];
    },
    editedDatasource() {
      return this.$store.getters["datasourcePhysicalStorage/editedDatasource"];
    },
    editedPhysicalStorage() {
      return this.$store.getters["datasourcePhysicalStorage/editedPhysicalStorage"];
    },
  },
  watch: {
    editedPhysicalStorage: {
      deep: true,
      immediate: true,
      handler(v) {
        this.unit = "month";
        if (v) {
          this.form = { ...v };
        }
        this.form.libraryItem = v?.libraryItem ? [v.libraryItem] : [];
      },
    },
  },
  mounted() {},
  methods: {
    applyRecommendation(recommendation) {
      this.form = {
        ...this.form,
        period: recommendation.period,
        since: recommendation.since,
        legalBasis: recommendation.legalBasis,
      };
      this.unit = "month";
    },

    cancel() {
      this.$store.dispatch("datasourcePhysicalStorage/resetForm");
      this.$root.$emit("bv::toggle::collapse", this.id);
    },
    async save() {
      if (!this.prepareMode) {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        this.form.datasource = { _id: this.editedDatasource };

        let period = this.form.period;
        if (this.unit == "year") {
          period = period * 12;
        }

        if (this.prepareMode) {
          if (this.editedPhysicalStorage?.libraryItem) {
            this.$store.commit("gdprInventoryBulkUpdate/removePhysicalStorage", this.editedPhysicalStorage);
          }
          this.$emit("onSaved", { ...this.form, period });
        } else {
          for (const item of this.form.libraryItem) {
            try {
              await this.$store.dispatch("datasourcePhysicalStorage/save", { ...this.form, libraryItem: item, period });
              this.$toast.success(this.$t("common.success"));
            } catch (error) {
              this.$handleHttpErrorByStatusCode(error);
            }
            this.$toast.success(this.$t("common.success"));
          }
        }

        this.$root.$emit("bv::toggle::collapse", this.id);
        this.$store.commit("datasourcePhysicalStorage/editedPhysicalStorage", null);
        this.form = { libraryItem: undefined, period: 12, since: undefined, legalBasis: undefined, description: undefined };
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async onStorageSearch(value, callback) {
      const response = await this.$store.dispatch(`physicalStorage/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onStorageSelect(item) {
      this.form = { ...this.form, libraryItem: item };
    },
  },
};
</script>
